import { render } from "./XdemiaIcon.vue?vue&type=template&id=6afa5798"
import script from "./XdemiaIcon.vue?vue&type=script&lang=js"
export * from "./XdemiaIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__